<template>
  <div class="image-field-container">
    <ImageUploaderModal
      v-if="isImageUploaderModalShowing"
      :imageObject.sync="imageObject"
      :imageViewSize="imageViewSize"
      :imageType="imageType"
      :tabMenu="tabMenu"
      :title="uploadTitle"
      :actionConfirmText="uploadButtonConfirmText"
      :imageOptions="imageOptions"
      :onCloseModal="onCloseImageUploaderModal" />
    <div class="image-field-header">
      <h5 class="name" v-if="!$slots['header']">{{title}}</h5>
      <slot name="header" />
      <div class="actions" v-if="!disabledChangeImage">
        <button
          v-if="!disabled"
          type="button"
          class="btn btn-link p-0"
          @click.stop="chooseImage">
          {{actionChooseImageText}}
        </button>
      </div>
    </div>
    <div class="image-field-preview">
      <ImageView
        :source="getImageSource()"
        :imageSize="imageViewSize"
        :aspectRatio="aspectRatio"
        :emptyMessageText="emptyMessageText" />
      <small class="help-text">
        {{hintText}}
      </small>
    </div>
  </div>
</template>

<script>
import ImageUploaderModal from './ImageUploaderModal.vue';
import ImageView from './ImageView.vue';

export default {
  props: {
    image: {
      type: Object,
      default: () => null,
    },
    defaultImage: {
      type: Object,
      default: () => null,
    },
    aspectRatio: {
      type: String,
      default: '16:9',
    },
    imageType: {
      type: String,
      default: 'generalCoverImage',
    },
    title: {
      type: String,
      default: 'รูปปก',
    },
    emptyMessageText: {
      type: String,
      default: 'ไม่มีรูปปก',
    },
    actionChooseImageText: {
      type: String,
      default: 'เลือกภาพ',
    },
    uploadTitle: {
      type: String,
      default: 'เลือกรูปปก',
    },
    uploadButtonConfirmText: {
      type: String,
      default: 'ใช้เป็นรูปปก',
    },
    hintText: {
      type: String,
      default: 'ขนาดภาพที่เหมาะสม 1280x720',
    },
    disabledChangeImage: {
      type: Boolean,
      default: false,
    },
    imageViewSize: {
      type: String,
      default: 'cover640w360h',
    },
    tabMenu: {
      type: Array,
      default: () => [
        {
          key: 'upload',
          value: 'อัปโหลดจากเครื่อง',
        },
        {
          key: 'information',
          value: 'เลือกจากลิสต์ภาพ',
        },
      ],
    },
    imageOptions: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ImageView,
    ImageUploaderModal,
  },
  data() {
    return {
      imageObject: null,
      isImageUploaderModalShowing: false,
    };
  },
  watch: {
    imageObject(newValue) {
      this.$emit('update:image', newValue);
      this.onCloseImageUploaderModal();
    },
  },
  methods: {
    chooseImage() {
      this.onToggleImageUploaderModal();
    },
    onCloseImageUploaderModal() {
      this.isImageUploaderModalShowing = false;
    },
    onToggleImageUploaderModal() {
      this.isImageUploaderModalShowing = !this.isImageUploaderModalShowing;
    },
    getImageSource() {
      if (this.image) {
        return this.image;
      }
      return this.defaultImage;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.image-field-header {
  display: flex;
  align-items: flex-end;

  .name {
    font-weight: normal;
    color: $body-color;
    font-family: $font-family-CSPrajad;
    font-size: $font-size-base;
  }

  .actions {
    margin-left: auto;
    margin-bottom: $spacer * 0.35;
    .btn {
      &:last-child {
        padding-right: 0;
      }
    }
  }
}
</style>
